import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { SimplePanel } from '../../shared/_panel';
import PersonalInfo from './PersonalInfo';
import PaymentMethods from './paymentMethods/PaymentMethods';
import Transactions from './transactions/_Transactions';
import { paymentDetailsFetch } from '../../../actions/PaymentDetailsActions';
import PropTypes from 'prop-types';
import SubscriptionDetails from './subscription/SubscriptionDetails';
import { connect } from 'react-redux';

class Edit extends React.Component {
  state = {
    carouselIndex: 0,
  };

  _handlePreviousCLick = () => {
    const tabList = document.querySelector('#js-tab-list');
    const childNodes = tabList.childNodes;

    if (this.state.carouselIndex === 0) {
      return;
    }
    this.setState(
      (state) => ({ carouselIndex: state.carouselIndex - 1 }),
      () => {
        childNodes[this.state.carouselIndex].style.display = 'inline-block';
      },
    );
  };

  _handleNextCLick = () => {
    const tabList = document.querySelector('#js-tab-list');
    const childNodes = tabList.childNodes;

    if (this.state.carouselIndex === childNodes.length - 2) {
      return;
    }
    this.setState(
      (state) => ({ carouselIndex: state.carouselIndex + 1 }),
      () => {
        childNodes[this.state.carouselIndex - 1].style.display = 'none';
      },
    );
  };

  componentDidMount() {
    const { fetchCards, currentUserId } = this.props;

    fetchCards(currentUserId);
  }

  render() {
    return (
      <div className="body__content body__content--center rep-edit">
        <SimplePanel className="rep-edit__panel" header="Settings">
          <Tabs>
            <div className={'tab-list-wrapper'}>
              <i
                className="fa fa-chevron-left tab-list__icon tab-list__icon--left"
                onClick={this._handlePreviousCLick}
              />
              <TabList id={'js-tab-list'}>
                <Tab>Payment methods</Tab>
                <Tab>Subscription details</Tab>
                <Tab>Personal information</Tab>
                <Tab>Transactions</Tab>
              </TabList>
              <i
                className="fa fa-chevron-right tab-list__icon tab-list__icon--right"
                onClick={this._handleNextCLick}
              />
            </div>
            <TabPanel>
              <PaymentMethods />
            </TabPanel>
            <TabPanel>
              <SubscriptionDetails />
            </TabPanel>
            <TabPanel>
              <PersonalInfo />
            </TabPanel>
            <TabPanel>
              <Transactions />
            </TabPanel>
          </Tabs>
        </SimplePanel>
      </div>
    );
  }
}

Edit.propTypes = {
  currentUserId: PropTypes.string.isRequired,
  fetchCards: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => {
  return {
    currentUserId: state.getIn(['currentUser', 'data', 'id']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCards: (id) => {
      dispatch(paymentDetailsFetch({ id }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Edit);



// WEBPACK FOOTER //
// ./app/components/reps/settings/Edit.jsx